export default __webpack_public_path__ + "static/media/rnr-sports-table-26-cn.a6361783.webp";